import React, { useEffect, useState } from "react";
import { 
  Menu, 
  MenuItem, 
  FormControlLabel, 
  Switch, 
  Radio, 
  RadioGroup, 
  FormControl, 
  FormLabel,
  Paper,
 } from "@mui/material";
 import { makeStyles } from "@material-ui/core/styles";
import TicketsQueueSelect from "../TicketsQueueSelect";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: "0.9rem",
    fontWeight: 600,
  },
}));

const TicketsFilterMenu = ({
  anchorEl,
  handleClose,
  user,
  selectedQueueIds,
  setSelectedQueueIds,
  selectedFilter,
  setSelectedFilter,
  selectedUsers,
  setSelectedUsers,
}) => {

  const classes = useStyles();

  const [users, setUsers] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadUsers();
    }
    fetchData();
  }, []);

  const handleFilterChange = (event) => {
    setSelectedFilter(event.target.value);
  };

  const loadUsers = async () => {
    try {
      const { data } = await api.get(`/users/list`);
      const userList = data.map((u) => ({ id: u.id, name: u.name }));
      setUsers(userList);
    } catch (err) {
      toastError(err);
    }
  }

  if (!anchorEl) return null; // ✅ Essa verificação pode continuar aqui


  return (
    <Menu
      id="filter-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
      <MenuItem>
        <FormControl component="fieldset">
          <FormLabel component="legend">Filtrar tickets por:</FormLabel>
          <RadioGroup value={selectedFilter} onChange={handleFilterChange}>
            <FormControlLabel
              value="queue"
              control={<Radio />}
              label="Filtrar por fila"
            />
            {selectedFilter === "queue" && (
              <TicketsQueueSelect
                style={{ marginLeft: 6 }}
                selectedQueueIds={selectedQueueIds}
                userQueues={user?.queues || []} // ⚠️ Evita erro se `user?.queues` for undefined
                onChange={(values) => setSelectedQueueIds(values)}
              />
            )}
            {user.profile === "admin" && (
              <>
                <FormControlLabel
                  value="users"
                  control={<Radio />}
                  label="Filtrar por usuários"
                />
                {selectedFilter === "users" && (
                  <Paper
                    style={{
                      padding: 12,
                      marginTop: 7,
                      marginLeft: 15,
                      maxHeight: 200,
                      overflowY: "auto",                      
                      display: "flex",
                      flexDirection: "column",                      
                    }}
                    variant="outlined"
                    elevation={1}
                    >
                    <RadioGroup
                      value={selectedUsers}
                      onChange={(e, v) => setSelectedUsers(v)}
                    >
                      {users?.length > 0 &&
                        users.map((user) => (
                          <FormControlLabel
                            key={user.id}
                            value={user.id}
                            control={<Radio size="small" color="secondary" />}
                            label={user.name}
                            classes={{ label: classes.label }}                            
                          />
                        ))}
                    </RadioGroup>
                  </Paper>
                )}
              </>
            )}
            <FormControlLabel
              value="fromMe"
              control={<Radio />}
              label="Última mensagem enviada por mim"
            />
            <FormControlLabel
              value="notFromMe"
              control={<Radio />}
              label="Última mensagem enviada pelo contato"
            />
          </RadioGroup>
        </FormControl>
      </MenuItem>
    </Menu>
  );
};

export default TicketsFilterMenu;
